import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const icons = {
  RequestQuoteIcon
};

const ClaimDetails = {
  id: 'ValidatePolicy',
  type: 'group',
  children: [
    {
      id: 'ValidatePolicy',
      title: 'Initiate Claim',
      type: 'item',
      url: '/Initiate-Claim',
      icon: icons.RequestQuoteIcon,
    }
  ]
};

export default ClaimDetails;
